import { Editor } from 'slate'

export function withEmojis(editor: Editor, options: any = {}) {
  return editor
}
